import { Form } from 'components/Wizards/Form/Form'
import { Formik } from 'formik'
import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { Field } from 'components/Wizards/Wizard/Form/Field'
import Styles from './PurposeAndGoals.module.scss'
import { Field as BaseField } from 'components/Wizards/Field/Field'
import { Button } from 'blaze-ui/Button/Button'
import { useState } from 'react'
import { MobileTopic } from './MobileTopic'
import { ConditionalLanguageInputField as LanguageInputField } from '../../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

interface Props extends StepProps {
  setFieldsCompleted: (val: boolean) => void
}

export const MobilePurposeAndGoals = multiStep<Props>(({ schema, initialValues, onSubmit, setFieldsCompleted }) => {
  const [isTopicSet, setIsTopicSet] = useState(false)
  const {
    meta: { submitLabel },
  } = schema.describe()

  const fieldsWithName = (names: string[]) => Object.entries(schema.fields).filter(([name]) => names.includes(name))

  const topicField = fieldsWithName(['topic'])[0]
  const brandKitField = fieldsWithName(['brand_kit_id'])[0]

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
      enableReinitialize
    >
      {({ isSubmitting, submitForm }) => {
        return (
          <Form.Root>
            {topicField && (
              <MobileTopic topicField={topicField[1]} isTopicSet={isTopicSet} setIsTopicSet={setIsTopicSet} />
            )}

            <Form.Section isDisabled={!isTopicSet} backgroundColor="var(--light-60)">
              <Form.SectionContent>
                <Form.Fields className={Styles.formFields}>
                  <BaseField
                    name="design_wizard_fields"
                    label=''
                    direction="column"
                  >
                    {brandKitField && (
                      <Field name={brandKitField[0]} schema={brandKitField[1]} labelType="text" />
                    )}
                  </BaseField>

                  {fieldsWithName(['tone', 'source_material_ids', 'brand_visual_kit_id']).map(([name, schema]) => (
                    <Field key={name} name={name} schema={schema} labelType="text" />
                  ))}

                  <LanguageInputField labelType="text" />
                </Form.Fields>
              </Form.SectionContent>
            </Form.Section>

            <Form.Actions isSticky>
              <Form.PrimaryActions>
                <Button
                  size="lg"
                  fullWidth
                  type="submit"
                  isDisabled={isSubmitting}
                  onPress={() => {
                    submitForm()
                    setFieldsCompleted(false)
                  }}
                >
                  {submitLabel}
                </Button>
              </Form.PrimaryActions>
            </Form.Actions>
          </Form.Root>
        )
      }}
    </Formik>
  )
})
